// TODO: CONVERT TO TYPESCRIPT
/* global errorPanel */

import React from 'react'
import PropTypes from 'prop-types'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { useModal } from 'components/common/modal/Modal'

const ListForm = ({ supplier, onCreateList }) => {
  const { setIsOpen } = useModal()
  const validate = (values) => {
    const errors = {}

    if (!values.name) {
      errors.name = 'Required'
    }

    return errors
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  return (
    <>
      <div className='pro-head-5 color-pro-steel-grey-600 lists-modal-header compact'>
        <h3 className='pro-head-5'>Create a New List</h3>
        <p className='pro-text-s color-pro-steel-grey-600'>Give your new list a name and we'll add {supplier.name} to it.</p>
      </div>
      <div className='lists-modal-body lists-form'>
        <Formik
          initialValues={{
            name: ''
          }}
          onSubmit={(values, actions) => {
            onCreateList(values.name, supplier.id)
              .then(() => {
                closeModal()
                actions.resetForm()
              })
              .catch(() => {
                errorPanel(
                  'List could not be created. Please try again or contact Support.'
                )
              })
          }}
          validate={validate}
        >
          <Form id='supplier-list-create-form'>
            <label htmlFor='name' className='pro-text-s pro-bold color-pro-steel-grey-600'>Name</label>
            <ErrorMessage name='name' />
            <Field
              id='name'
              name='name'
              placeholder='List Name'
              className='list-field'
            />
            <div className='grid-x align-justify align-middle'>
              <button className='cancel-button lists-modal-cancel color-pro-steel-grey-600' type='button' onClick={closeModal}>
                Cancel
              </button>
              <button type='submit' className='button submit-button'>
                Create List
                <i className='fas fa-pen-square inline-icon-right' />
              </button>
            </div>
          </Form>
        </Formik>
      </div>
    </>
  )
}

ListForm.propTypes = {
  supplier: PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }).isRequired,
  onCreateList: PropTypes.func.isRequired
}

export default ListForm
